import styled from 'styled-components';

export const SearchBarDropdownWrapper = styled.div`
   position: relative;
`;

export const DropdownWrapper = styled.div`
   position: absolute;
   bottom: -100%;
   left: 0;
   width: 100%;
   height: 100%;
`;
